// RECURSOS DO PORTAL DA ORGANIZACAO — a lista que a permissao e o papel usam.
//
// Vivia so' em `apps/web/src/lib/prefeitura-perms.ts`, e por isso as permissoes
// granulares do sub-usuario eram aplicadas SO' NO MENU: o servidor nao tinha a
// lista para conferir contra. A feature 009 passa a conferir escopo e permissao
// no servidor (FR-018/FR-019), e para isso a API e a web precisam ler a MESMA
// lista — dai ela morar aqui, na folha da arvore de dependencias.
//
// Cada chave e' um recurso do portal, e e' por ela que duas coisas decidem:
//
//   - o PAPEL da relacao institucional (o que a organizacao responsavel pode
//     fazer na atendida) — ver PAPEL_LIBERA em @atlas/domain;
//   - a PERMISSAO do sub-usuario (o que aquela pessoa pode fazer).
//
// O acesso efetivo e' a intersecao dos dois. A funcao `podeAcessar` e o leitor de
// JWT continuam na web, porque sao de cliente; aqui fica so' o vocabulario.
/** Recursos agrupados por categoria. Espelha o menu do portal. */
export const PREFEITURA_RESOURCE_GROUPS = [
    {
        titulo: "Geral",
        recursos: [
            { key: "dashboard", label: "Painel" },
            { key: "conta", label: "Minha conta" },
        ],
    },
    {
        titulo: "Recursos Humanos",
        recursos: [
            { key: "servidores", label: "Servidores" },
            { key: "convenios", label: "Convenios" },
            { key: "contratos", label: "Contratos averbados" },
        ],
    },
    {
        titulo: "Financeiro / Folha",
        recursos: [
            { key: "folhas", label: "Folhas" },
            { key: "troca-arquivos", label: "Troca de arquivos" },
            { key: "adf", label: "ADF / Descontos" },
            { key: "relatorios", label: "Relatorios" },
            { key: "repasses", label: "Repasses", descricao: "Registrar e consultar o repasse aos credores" },
        ],
    },
    {
        titulo: "Comunicacao & LGPD",
        recursos: [
            { key: "comunicados", label: "Comunicados" },
            { key: "anuencia", label: "Anuencia de dados" },
        ],
    },
    {
        titulo: "Administracao",
        recursos: [
            { key: "perfis", label: "Usuarios e acessos" },
            // Feature 009: a configuracao da unidade (exigencia de senha, contato,
            // exclusividades) era escrita sob a chave `conta`, que e' do PROPRIO
            // usuario. Sao coisas diferentes — uma muda a senha de quem esta logado, a
            // outra muda como toda a folha opera — e so' a segunda pode ser exercida
            // por uma organizacao responsavel sobre a atendida. Chave nova, concedida
            // por default apenas ao preset `gestor`: perfil ja gravado sem ela
            // continua sem, porque e' escrita sensivel.
            { key: "config", label: "Configuracoes da unidade" },
        ],
    },
];
export const PREFEITURA_TODAS_PERMISSOES = PREFEITURA_RESOURCE_GROUPS.flatMap((g) => g.recursos.map((r) => r.key));
export const PREFEITURA_PRESETS = {
    gestor: ["*"],
    rh: ["dashboard", "servidores", "convenios", "contratos", "adf", "anuencia", "comunicados", "conta"],
    financeiro: [
        "dashboard",
        "folhas",
        "troca-arquivos",
        "contratos",
        "adf",
        "relatorios",
        "comunicados",
        "conta",
    ],
    personalizado: [],
};
/**
 * Chaves que passaram a valer por outra, quando duas telas viraram uma.
 *
 * `troca-arquivos` aceita quem tem `folhas`: a tela /prefeitura/folhas foi
 * absorvida pela aba Competencias de Troca de arquivos em 28/08/2026. A chave
 * antiga continua concedida nos perfis JA GRAVADOS, e sem este mapa quem tinha
 * so' `folhas` perderia acesso ao que tinha — uma mudanca de layout tirando
 * permissao de alguem, em silencio.
 *
 * E' a alternativa a migrar as permissoes gravadas de todos os perfis, que seria
 * irreversivel e mais arriscado do que aceitar um alias.
 */
export const ALIAS_PERMISSAO = {
    "troca-arquivos": ["folhas"],
};
/** `null`/vazio = login da organizacao (ve tudo); `"*"` = wildcard. Usada no
 *  cliente e, desde a feature 009, tambem no servidor. */
export function permissaoCobre(permissoes, key) {
    if (!permissoes || permissoes.length === 0)
        return true;
    if (permissoes.includes("*"))
        return true;
    if (permissoes.includes(key))
        return true;
    return (ALIAS_PERMISSAO[key] ?? []).some((a) => permissoes.includes(a));
}
//# sourceMappingURL=prefeitura-recursos.js.map